import React from 'react';

const Footer = () => {
  return (
    <footer className="text-white" style={{ backgroundColor: '#2f4c74' }}>
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-8 py-12">
        <div className="flex flex-col lg:flex-row justify-between gap-8">
          {/* Brand & Contact */}
          <div id="referrals" className="flex flex-col sm:flex-row items-start gap-6">
            <img
              src="/assets/images/logo12.png"
              alt="Testa Care logo"
              className="h-24 w-auto object-contain"
              loading="lazy"
            />
            <div className="text-sm leading-relaxed text-white">
              <p>Davyfield Road, Blackburn, Lancashire, England, BB1 2QY</p>
              <p className="mt-3">
                Email:{' '}
                <a href="mailto:Info@testacare.co.uk" className="text-white hover:opacity-80 transition">
                  Info@testacare.co.uk
                </a>
              </p>
              <p className="mt-2">T: +44 (0)7767 054238</p>
            </div>
          </div>

          {/* Navigation & Social */}
          <div className="flex flex-col items-start lg:items-end gap-6">
            {/* Navigation Links */}
            <div className="flex gap-4 text-base">
              <a href="/our-homes" className="text-white hover:opacity-80 transition">Our Homes</a>
              <span className="text-white">|</span>
              <a href="/our-team" className="text-white hover:opacity-80 transition">Our Team</a>
              <span className="text-white">|</span>
              <a href="/therapy-services" className="text-white hover:opacity-80 transition">Therapy Services</a>
            </div>

            {/* Social Icons */}
            <div className="flex gap-4">
              <a href="https://www.linkedin.com/company/testa-care" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-white flex items-center justify-center hover:bg-white hover:text-[#2f4c74] transition">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                </svg>
              </a>
              <a href="https://facebook.com" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full border border-white flex items-center justify-center hover:bg-white hover:text-[#2f4c74] transition">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/>
                </svg>
              </a>
            </div>

            {/* Badge */}
            <div className="bg-transparent border border-white px-4 py-2 text-xs self-stretch lg:self-end text-center text-white">
              <div>Restraint</div>
              <div>Reduction</div>
              <div>Network</div>
              <div className="text-[10px]">Member</div>
            </div>
          </div>
        </div>
      </div>

      {/* Orange Line */}
      <div className="h-1 bg-orange-500"></div>

      {/* Bottom Copyright Section */}
      <div className="py-6" style={{ backgroundColor: '#244061' }}>
        <div className="max-w-7xl mx-auto px-8 flex flex-col md:flex-row justify-between items-start md:items-center text-xs text-white">
          <div className="flex items-start gap-4 mb-4 md:mb-0">
            <div>
              <p>Copyright {'\u00A9'} 2025 Testa Care | Testa Care is owned by Sigma Universal Ltd</p>
              <p className="mt-2">
                <a href="https://www.azidogroup.com" target="_blank" rel="noopener noreferrer" className="hover:opacity-80 transition">
                  Powered by Azido Group Web Services
                </a>
              </p>
            </div>
          </div>
          <div className="flex gap-4 whitespace-nowrap">
            <a href="/privacy" className="hover:opacity-80 transition">Privacy</a>
            <span>|</span>
            <a href="/cookies" className="hover:opacity-80 transition">Cookies</a>
            <span>|</span>
            <a href="/terms-of-use" className="hover:opacity-80 transition">Terms of Use</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
